'use es6';

import { Map as ImmutableMap } from 'immutable';
import { Style } from 'reporting-visualizations/visualizations/xy/xyRecords';
export const applyAxesProperties = (visualization, report) => {
  const xAxis = report.getIn(['displayParams', 'xAxis'], ImmutableMap());
  const yAxis = report.getIn(['displayParams', 'yAxis'], ImmutableMap());
  return visualization.update('style', (style = Style({})) => style.update('x', (xStyles = ImmutableMap()) => xStyles.update('bottom', (bottomStyle = ImmutableMap()) => bottomStyle.update('title', title => {
    if (!xAxis.getIn(['title', 'enabled'], true)) {
      return '';
    }
    return xAxis.getIn(['title', 'text']) || title;
  }).set('min', xAxis.getIn(['bounds', 'min'])).set('max', xAxis.getIn(['bounds', 'max'])).update('type', type => xAxis.get('type') || type))).update('y', (yStyles = ImmutableMap()) => yStyles.update('left', (leftStyle = ImmutableMap()) => leftStyle.update('title', title => {
    if (!yAxis.getIn(['title', 'enabled'], true)) {
      return '';
    }
    return yAxis.getIn(['title', 'text']) || title;
  }).set('min', yAxis.getIn(['bounds', 'min'])).set('max', yAxis.getIn(['bounds', 'max'])).update('type', type => yAxis.get('type') || type))));
};